import { LoadingStates } from '@pb/utils'

export default {
  cartCode: '',
  items: [],
  oosItems: [],
  hazmatItems: [],
  hiddenItems: [],

  orderTotals: undefined,

  deliveryAddress: undefined,
  pickUpInStoreData: undefined,

  codLimitReached: false,

  vatMessageRequired: false,
  taxDisclaimerRequired: false,
  returnAndRefundRequired: false,
  fineprintReturnAndRefundRequired: false,
  returnDays: '',

  isCartLoading: false,
  isCartPopulated: false,
  isCartLoadingFailed: false,

  addGiftCardStatus: LoadingStates.Loading,
  giftCardsApplied: [],
  giftCardError: {
    isWarningMessage: false,
    message: '',
  },

  oneClickCheckoutLoading: false,
  oneClickCheckoutCompleted: false,
  oneClickCheckoutFailed: false,
  oneClickCheckoutInfo: {},

  infoMessage: {},
  paymentModes: [],
  supportedCreditCards: [],

  isMiddlePage: false,
}
